import React, {Component} from 'react';
import PropTypes from "prop-types";
import WithUserState from "./user/WithUserState";
import Icon from "./Icon";
import SignInButton from "./user/SignInButton";
import VoteApi from "../api/VoteApi";

class FavoriteButton extends Component {
  static propTypes = {
    object: PropTypes.object.isRequired,
    voteData: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      favorised: props.voteData.favorised
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.voteData.favorised !== this.props.voteData.favorised) {
      this.setState({
        favorised: this.props.voteData.favorised
      })
    }
  }

  onButtonClick(e) {
    const { object } = this.props;
    e.preventDefault();

    if (this.state.loading) {
      return;
    }

    this.setState({
      loading: true
    }, () => {
      VoteApi.favorise(object.type, object.slug).then((res) => {
        this.setState({
          loading: false,
          favorised: res.data.status
        })
      });
    })
  }

  render() {
    let classes = ["btn btn-block"];
    if (this.props.className) {
      classes.push(this.props.className);
    }

    if (this.state.favorised) {
      classes.push("btn-primary");
    } else {
      classes.push("btn-default");
    }

    return (
      <React.Fragment>
        <WithUserState state={"loggedIn"}>
          <button className={classes.join(" ")} onClick={this.onButtonClick.bind(this)}><Icon icon={'heart'}/> Favorise</button>
        </WithUserState>
        <WithUserState state={"loggedOut"}>
          <SignInButton className={classes.join(" ")}><Icon icon={'heart'}/> Favorise</SignInButton>
        </WithUserState>
      </React.Fragment>
    );
  }
}

export default FavoriteButton;